import { render, staticRenderFns } from "./EmptyRouter.vue?vue&type=template&id=178784ba&"
import script from "./EmptyRouter.vue?vue&type=script&lang=js&"
export * from "./EmptyRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports